var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title__wrapper"},[_c('div',{staticClass:"el-divider"}),_c('span',{staticClass:"notice_title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }